export default __webpack_public_path__ + "static/media/webDev_illus.eb24f26b.svg";